import $ from "jquery";
import {Adapter} from "./adapter";

export default class ImageAdapter extends Adapter {


    setup() {
        /** @type {AdapterItem[]} */
        this._elements = [];
        this.dialog.items.forEach(/** @param item {DialogItem} */(item) => {
            const $img = $('<img>', {
                'data-src': item.src,
                alt: item.alt,
                class: 'popup__image',
            });
            this._elements.push({
                $el: $img,
                src: item.src,
                title: item.title || '',
                ready: () => {
                    return new Promise((resolve, reject) => {
                        const img = $img[0];
                        if ($img.attr('data-src')) {
                            $img.on('load', () => {
                                $img.attr('width', img.naturalWidth);
                                $img.attr('height', img.naturalHeight);
                                resolve(img);
                            });
                            $img.on('error', () => {
                                console.log('error', img);
                                reject(img);
                            });
                            $img.attr('src', $img.attr('data-src'));
                            $img.removeAttr('data-src');
                        } else {
                            resolve(img);
                        }
                    });
                },
            });
        });
    }


    /**
     * @param index {number}
     * @returns {AdapterItem}
     */
    getForIndex(index) {
        if (this.hasNext(index)) {
            this._imagePreLoader(this.nextIndex(index));
        }
        if (this.hasPrev(index)) {
            this._imagePreLoader(this.prevIndex(index));
        }
        return super.getForIndex(index);
    }

    async _imagePreLoader(index) {
        const item = this._elements[index];
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = () => reject(new Error(`Failed to load image: ${item.src}`));
            img.src = item.src;
        });
    }
}
